export default __webpack_public_path__ + "static/media/mad-80s-01.ccffdb9a.jpg";